import { gql } from "@apollo/client"

export const STANDARD_QUERY = `
  id
  name
  description
   meta {
      canUnpublish
      canDelete
      canTag
      publishDate
      path
      fullPath
      publishStatus
      level
      pathNodes {
        id
        name
      }
    }
  parentNodeId
  sortIndex
`

export const STANDARD_GRAPH_QUERY = `
  id
  name
  description
  hasChildren
  meta {
    level
    canDelete
    canUnpublish
    path
    publishDate
    pathNodes {
      id
      name
    }
    publishStatus
  }
  parentNodeId
  sortIndex
  children {
    ${STANDARD_QUERY}
  }
`

export const STANDARDS_DRAFT_QUERY = `
  draftId
  meta {
    canPublish
  }
  ownerId
  ownerName
  standards {
    ${STANDARD_QUERY}
  }
  version
`

export const GET_PUBLISHED_STANDARDS_BY_PROGRAM_COURSE = gql`
  query getPublishedStandardsByProgramCourse($data: ProgramCourseInput!) {
    standards {
      getPublishedStandardsByProgramCourse(data: $data) {
        draftLastModify
        draftOwnerId
        draftVersion
        hasDraft
        standards {
          ${STANDARD_QUERY}
        }
      }
    }
  }
`

export const GET_DRAFT_STANDARD_BY_ID = gql`
  query getDraftStandardById($data: StandardDraftGetByIdInput!) {
    standards {
      getDraftStandardById(data: $data){
        ${STANDARD_QUERY}
      }
    }
  }
`

export const GET_DRAFT_STANDARD_EDIT_HISTORY = gql`
  query getDraftStandardEditHistory($data: DraftStandardSession!) {
    standards {
      getDraftStandardEditHistory(data: $data) {
        authorId
        authorName
        actionCode
        logCode
        logParams
        timestamp
        description
        publishable
      }
    }
  }
`

export const GET_PUBLISHED_STANDARD_BY_ID = gql`
  query getPublishedStandardById($data: StandardIdInput!) {
    standards {
      getPublishedStandardById(data: $data){
        ${STANDARD_QUERY}
      }
    }
  }
`

export const GET_FRAMEWORKS_AND_STRANDS = gql`
  query getAllStandardsGraph($data: StandardV2Request!) {
    standardsV2 {
      getAllStandardsGraph(data: $data){
        ${STANDARD_GRAPH_QUERY}
      }
    }
  }
`

export const GET_ALL_STANDARDS = gql`
  query getAllStandardsList($data: StandardV2Request!) {
    standardsV2 {
      getAllStandardsList(data: $data){
        ${STANDARD_QUERY}
      }
    }
  }
`

export const GET_PUBLISHED_STANDARDS_LIST = gql`
  query getPublishedStandardsList($data: StandardV2Request!) {
    standardsV2 {
      getPublishedStandardsList(data: $data){
        ${STANDARD_QUERY}
      }
    }
  }
`
